import React, { useEffect } from 'react';
import Typed from 'typed.js';

const TypingComponent = () => {
  useEffect(() => {
    const slides = document.querySelector('.slides');
    const images = slides.querySelectorAll('img');

    images.forEach((image, i) => {
      image.setAttribute('data-id', i + 1);
    });

    const typed = new Typed('.typed-words', {
      strings: [
        'Seaside Secrets.',
        'Wings of Wonder.',
        'Amphibian Realm.',
        'Wild Wanderers.',
        'Vanishing Treasures.',
        'Animals.',
      ],
      typeSpeed: 80,
      backSpeed: 80,
      backDelay: 3000,
      startDelay: 1000,
      loop: true,
      showCursor: true,
      preStringTyped: (arrayPos, self) => {
        arrayPos++;
        const slidesImages = document.querySelectorAll('.slides img');
        slidesImages.forEach((img) => img.classList.remove('active'));
        const targetImage = document.querySelector(
          `.slides img[data-id="${arrayPos}"]`
        );
        if (targetImage) {
          targetImage.classList.add('active');
        }
      },
    });

    return () => {
      typed.destroy();
    };
  }, []);
}

export default TypingComponent;
